module.exports = __webpack_public_path__ + "pc/img/about-global-person05.b3964eee.png";